import React, { useState, createContext, useCallback, useEffect } from "react";
import Axios from "axios";
import {
  getDeviceId,
  setDeviceId,
  setToken,
  getToken,
} from "../GlobalFunctions";

export const UserDataContext = createContext();

const UserDataContextProvider = (props) => {
  const [userData, setUserData] = useState({});

  console.log("Rerender");

  const verifyToken = useCallback(async () => {
    console.log("authenticating");
    try {
      const res = await Axios({
        method: "POST",
        url: "/users/verifyJWT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${getToken()}`,
        },
      });

      const { token, ...rest } = res.data; // destructure the token out of the result
      setUserData({
        ...userData,
        loggedIn: true,
        token: getToken(),
        ...rest,
      });

      return res;
    } catch (error) {
      setUserData({
        ...userData,
        loggedIn: false,
      });
      console.log(error);
    }
  }, [userData]);

  const login = useCallback(async (username, password, onFailCallback) => {
    try {
      const res = await Axios({
        method: "POST",
        url: "/users/authenticate",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          username,
          password,
          mfaGuid: getDeviceId(),
        },
      });

      const { token, trucks, ...rest } = res.data;

      if (!getDeviceId()) {
        setDeviceId(res.data.mfaGuid);
      }

      if (res.status === 200) {
        setToken(token);
        setUserData({
          ...rest,
          trucks: trucks || [],
          token,
          loggedIn: true,
        });
        console.log("loggedIn");
      } else if (res.status === 202) {
        setUserData({
          ...rest,
          mfaRequired: true,
        });
      }

      return res;
    } catch (err) {
      console.log(err);
      onFailCallback(err.response.data.message);
    }
  }, []);

  const logout = useCallback(() => {
    setToken("");
    setUserData({});
    removeInvoiceSearchFilters();
    window.stop();
  }, []);

  const removeInvoiceSearchFilters = () => 
  {
    localStorage.removeItem("selectedTrucksInvoice");
    localStorage.removeItem("startDateInvoice");
    localStorage.removeItem("endDateInvoice");
    localStorage.removeItem("approvalStateInvoice");
    localStorage.removeItem("userSearchedInvoice");
  }

  const verifyMfa = useCallback(
    async (mfaCode, onFailCallback) => {
      try {
        const res = await Axios({
          method: "POST",
          url: "/users/verifymfacode",
          headers: {
            "content-type": "application/json",
          },

          data: { ...userData, token: mfaCode },
        });
        setToken(res.data.token);
        setUserData({
          ...res.data,
          trucks: res.data.trucks || [],
          loggedIn: true,
        });
        console.log("loggedIn");
      } catch (err) {
        onFailCallback(err.response.data.message);
        console.log(err);
      }
    },
    [userData]
  );

  return (
    <UserDataContext.Provider
      value={{ userData, setUserData, login, logout, verifyMfa, verifyToken }}
    >
      {props.children}
    </UserDataContext.Provider>
  );
};

export default UserDataContextProvider;
